import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Phone, FileUp } from 'lucide-react';
import { company } from '../mock';

/**
 * Floating action stack — desktop + mobile.
 * Positioned bottom-right above the Emergent badge so it overlays / covers it.
 */
export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const isContact = location.pathname === '/contact';
  const isCrm = location.pathname.startsWith('/crm');

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 280);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (isCrm) return null;

  return (
    <div
      className={`fixed z-[60] right-3 md:right-4 bottom-3 md:bottom-4 flex flex-col items-end gap-2 transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      aria-hidden={!visible}
    >
      {/* Phone CTA — pill */}
      <a
        href={`tel:${company.phoneRaw}`}
        className="flex items-center gap-2 bg-[#0B1B33] hover:bg-[#11264a] text-white pl-3 pr-4 py-2.5 rounded-full shadow-2xl border border-amber-400/30 group"
        aria-label={`Call ${company.phone}`}
      >
        <span className="w-8 h-8 rounded-full bg-amber-500 text-[#0B1B33] flex items-center justify-center group-hover:scale-105 transition">
          <Phone className="w-4 h-4" strokeWidth={2.5} />
        </span>
        <span className="hidden sm:block text-sm font-semibold">{company.phone}</span>
      </a>

      {/* Quote CTA — main */}
      {!isContact && (
        <Link
          to="/contact"
          className="flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-[#0B1B33] pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-amber-500/40 font-semibold text-sm group"
        >
          <FileUp className="w-4 h-4" strokeWidth={2.5} />
          <span>Upload Drawings</span>
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition" />
        </Link>
      )}
    </div>
  );
}
